// views/Admin/Statistics/components/Charts/BeaconCharts/BeaconCharts.tsx
import Card from '../../../../../../components/common/Card/Card';
import QrScansCharts from './QrScans/QrScansCharts';
import ConversionRatioChart from './ConversionRatio/FunnelStaticChart/FunnelStaticChart';
import styles from './BeaconCharts.module.css';

const BeaconCharts = () => (
  <div className={styles.beaconCharts}>
    <Card className={styles.beaconChart}>
      <ConversionRatioChart />
    </Card>
    <Card className={styles.beaconChart}>
      <QrScansCharts />
    </Card>
  </div>
);

export default BeaconCharts;
